<template>
    <v-app class="app">
        <router-view v-if="show" />
    </v-app>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            show: false
            // echo: undefined
        };
    },
    methods: {
        initiate() {
            this.events();
            this.checkToken();

            if (this.$cookies.get('asyncTaskIDPoll') != null) {
                this.$eventBus.$emit('check-merchants-qr-status');
            }
            // this.websocketSetup();
            // this.setTheme();
        },
        events() {
            this.$eventBus.$on('clear-data', this.clearData);
            this.$eventBus.$on('check-merchants-qr-status', this.checkMerchantsQRStatus);
        },
        checkMerchantsQRStatus() {
            this.qrStatusPoll = setInterval(() => {
                let id = window.atob(this.$cookies.get('asyncTaskIDPoll'));
                this.$store
                    .dispatch('merchants/checkMerchantsQRStatus', { id: id })
                    .then((response) => {
                        if (response.data.status == 'DONE') {
                            let output = response.data.output;
                            let fileName = output.file_name;

                            this.$store
                                .dispatch('merchants/downloadAsyncMerchantsQR', {
                                    id: id,
                                    data: {
                                        file_name: fileName
                                    },
                                    config: {
                                        responseType: 'blob'
                                    }
                                })
                                .then(() => {
                                    // Remove interval and asyncTaskIDPoll cookie
                                    this.$cookies.remove('asyncTaskIDPoll');
                                    let module = this.$cookies.get('asyncTaskModule') || 'Merchants';
                                    this.$notify({
                                        group: 'main-notifications',
                                        type: 'success',
                                        duration: 5000,
                                        title: `${module} - QR Download`,
                                        text: 'QR Generation Completed'
                                    });

                                    // this.notification({ type: 'success', message: response.message || 'Successfully downloaded all QR' });
                                    clearInterval(this.qrStatusPoll);
                                    // this.$eventBus.$off('check-merchants-qr-status');
                                })
                                .catch(() => {
                                    // Remove interval and asyncTaskIDPoll cookie
                                    this.$cookies.remove('asyncTaskIDPoll');
                                    // Remove asyncTaskModule
                                    this.$cookies.remove('asyncTaskModule');
                                    clearInterval(this.qrStatusPoll);
                                    // console.log(error);
                                });
                        }
                        // console.log(response);
                    })
                    .catch(() => {
                        // Remove interval and asyncTaskIDPoll cookie
                        this.$cookies.remove('asyncTaskIDPoll');
                        // Remove asyncTaskModule
                        this.$cookies.remove('asyncTaskModule');
                        clearInterval(this.qrStatusPoll);
                    });
            }, 5000);
        },
        async refreshToken(accessToken, userInfoCookie) {
            if (userInfoCookie.isRemember) {
                try {
                    this.$api.setAuthorization(window.atob(accessToken));
                    await this.$store.dispatch('authentication/refreshToken').then((response) => {
                        accessToken = window.atob(response.access_token);
                        this.$cookies.set('token', window.btoa(accessToken));
                        this.$api.setAuthorization(accessToken);

                        return accessToken;
                    });
                } catch (e) {
                    this.clearData();
                    return null;
                }
            }

            return accessToken;
        },
        checkToken() {
            let accessToken = this.$cookies.get('token');
            const userInfoCookie = this.$cookies.get('user-info') && this.$cookies.get('user-info') !== null ? JSON.parse(atob(this.$cookies.get('user-info'))) : null;
            // query = new URLSearchParams(window.location.search);
            if (accessToken && userInfoCookie) {
                // this.$api.setAuthorization(accessToken);
                accessToken = this.refreshToken(accessToken, userInfoCookie);
            }

            if (accessToken) {
                // this.$store.dispatch('authentication/setToken', accessToken);
                // Check token if is still valid,
                // and get user info
                const config = {
                    params: { appends: ['role', 'permissions', 'merchant'] }
                };
                this.$store
                    .dispatch('authentication/fetchUserInfo', { config: config })
                    .then(() => {
                        // console.log(response);
                        // this.setUserInfo(response.data);
                        this.show = true;
                    })
                    .catch(() => {
                        // console.log(error);
                        this.$router.push('/');
                        this.show = true;
                    });
            } else {
                this.show = true;
            }
        },
        // setUserInfo(data) {
        //     const user_token = this.$cookies.get('token'),
        //         user_info = this.$cookies.get('user-info');
        //     if (!user_token && !user_info) {
        //         this.$cookies.set('token', access_token);
        //         this.$cookies.set('user-info', window.btoa(JSON.stringify(data))); // Encode To Base64
        //         this.$router.replace({ query: {} });
        //         setTimeout(() => {
        //             this.show = true;
        //         }, 500);
        //     }
        // },
        // setTheme() {
        //     this.$vuetify.theme.dark = this.$store.getters['theme/isDarkMode']
        // },
        clearData() {
            // const user_info = this.$cookies.get('user-info');
            // { login_link } = user_info ? JSON.parse(window.atob(user_info)) : {}; // Decode Base64
            this.$store.dispatch('clearState');
            this.$cookies.remove('token');
            this.$cookies.remove('user-info');
            this.$cookies.remove('permission');

            this.$api.setAuthorization(undefined);

            // Remove asyncTaskModule and asyncTaskIDPoll cookie
            this.$cookies.remove('asyncTaskIDPoll');
            this.$cookies.remove('asyncTaskModule');

            // Clear qr status poll interval
            clearInterval(this.qrStatusPoll);

            this.$router.push({ name: 'login' });
        }
    },
    mounted() {
        this.initiate();
        // Detect System Dark Mode
        // if (!!window && !!window.matchMedia) {
        //     this.$vuetify.theme.dark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        // }
    },
    beforeDestroy() {
        this.$eventBus.$off('clear-data');
        this.$eventBus.$off('check-merchants-qr-status');
        // clearInterval(this.qrStatusPoll);
    }
};
</script>

<style lang="scss">
@import '@/assets/css/main.scss';
@import url('https://fonts.googleapis.com/css?family=Material+Icons');
</style>
